import React, {useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {useTheme} from "../../../../../connectui/theme/ThemeProvider";
import {buildStyles} from "../../../../../connectui/component/buildStyles";
import Container from "../../../../../connectui/component/layout/Container";
import FlexContainer from "../../../../../connectui/component/layout/FlexContainer";
import ButtonText from "../../../../../connectui/component/input/button/ButtonText";
import Text from "../../../../../connectui/component/display/Text";
import EmptyButtonBase from "../../../../../connectui/component/input/button/base/EmptyButtonBase";
import CircularSpinner from "connectui/component/display/CircularSpinner";

const useStyles = (theme) =>
  buildStyles({
    cardContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(3),
      overflow: "hidden",
      padding: theme.spacing(4, 3, 3),
      backgroundColor: theme.colors.primary50,
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  });

const ActionApproveDeclineCard = ({booking, handleAction}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const loadingCreateAction = useSelector(
    (state) => state.defaultReducer.loading,
  ).create_action;
  const [loadingAction, setLoadingAction] = useState({index: null, type: null});
  const bookingActions = useMemo(() => {
    const mergedActions = [];
    mergedActions.push(...(booking?.actions?.booking_actions || []));
    mergedActions.push(...(booking?.actions?.bp_actions || []));
    mergedActions.push(...(booking?.actions?.bp_upsells || []));
    mergedActions.push(...(booking?.actions?.bp_fees || []));
    return mergedActions;
  }, [booking]);
  const isActionInProgress =
    loadingCreateAction || loadingAction.index !== null;

  const handleActionClick = (props, type, index) => () => {
    setLoadingAction({index, type});
    handleAction(props, type, () =>
      setLoadingAction({index: null, type: null}),
    );
  };

  return (
    <FlexContainer flexDirection="column" gap={theme.spacing(0.5)}>
      {bookingActions.map((props, index) => (
        <Container
          key={`${props?.label}-${index}`}
          className={classes.cardContainer}
        >
          <Text variant={"textMD"} weight={"semibold"}>
            {props?.label}
          </Text>
          <FlexContainer
            alignItems={"center"}
            gap={theme.spacing(2)}
            width="100%"
          >
            <ButtonText
              label={
                loadingAction.index === index &&
                loadingAction.type === "confirm" ? (
                  <CircularSpinner color="white" />
                ) : (
                  "Approve"
                )
              }
              disabled={isActionInProgress}
              typographyVariant="textSM"
              weight="semibold"
              color="primary25"
              onClick={handleActionClick(props, "confirm", index)}
              sx={{flex: 1, padding: theme.spacing(1, 3.5)}}
            />
            <ButtonText
              label={
                loadingAction.index === index &&
                loadingAction.type === "deny" ? (
                  <CircularSpinner />
                ) : (
                  "Decline"
                )
              }
              disabled={isActionInProgress}
              buttonBase={EmptyButtonBase}
              typographyVariant="textSM"
              weight="semibold"
              color="gray700"
              onClick={handleActionClick(props, "deny", index)}
              sx={{flex: 1, padding: theme.spacing(1, 3.5)}}
            />
          </FlexContainer>
        </Container>
      ))}
    </FlexContainer>
  );
};
export default ActionApproveDeclineCard;
